import { TypographyVariant } from '@ben/orion/typography';
import { formatCurrency } from '@ben/orion/utils/currency';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TitleCell } from '../title-cell';

interface RewardAmountCellProps {
  amount?: string | null;
  amountPerRecipient?: string | null;
  currency?: string | null;
  title?: string | null;
}

const RewardAmountCell = ({
  amount,
  amountPerRecipient,
  currency,
  title,
}: RewardAmountCellProps) => {
  const { t } = useTranslation();
  const multipleRecipients = amountPerRecipient !== amount;

  if (!amount) {
    return title || '-';
  }

  return (
    <TitleCell
      title={
        amountPerRecipient ? formatCurrency(amountPerRecipient, currency) : '-'
      }
      titleVariant={TypographyVariant.bodyMd1}
      subtitle={
        multipleRecipients
          ? t('recognition.totalSpend', {
              amount: formatCurrency(amount, currency),
            })
          : undefined
      }
    />
  );
};

export default memo(RewardAmountCell);
